const MessageType = {
  text: "0",
  image: "1",
  file: "2",
  voice : '3',
};
export default MessageType;
